import styled from 'styled-components';

import { FormLeavingEventInterceptor } from '@dreryk/react-components';

export const StyledFormsTemplatesFormLeavingEventInterceptor = styled(FormLeavingEventInterceptor)`
   height: 100%;
   width: 100%;
`;
